module.exports = __webpack_public_path__ + "media/images/lb/747-6cedebd64795f925ad4a4a665fe8181b.svg";